export default __webpack_public_path__ + "static/media/README.0f5f6558.md";